import { API_PATHS } from "../constants/api-paths";
import { encryptedRequest, type IResponse } from "../core/api.client";

export type SaveMfLastVisitedRequest = {
  mobile: string;
  bseSchCode: string;
};

export type GetMfLastVisitedRequest = {
  mobile: string;
};

export type MfLastVisitedFundItem = {
  schemeName?: string;
  mainCategory?: string;
  category?: string;
  schemeRating?: string | number;
  minSIPAmount?: number;
  threeYrReturn?: number;
  logo?: string;
  amcSlug?: string;
  bseSchCode?: string;
};

export type MfLastVisitedData = {
  description?: string;
  statuscode?: string;
  bseSchCode?: string[];
  items?: MfLastVisitedFundItem[];
};

export const saveMfLastVisitedFund = async ({
  mobile,
  bseSchCode,
}: SaveMfLastVisitedRequest): Promise<IResponse<unknown>> => {
  return encryptedRequest<unknown, SaveMfLastVisitedRequest>({
    method: "POST",
    url: API_PATHS.saveMfLastVisited,
    data: {
      mobile,
      bseSchCode,
    },
  });
};

export const getMfLastVisitedFunds = async ({
  mobile,
}: GetMfLastVisitedRequest): Promise<IResponse<MfLastVisitedData>> => {
  return encryptedRequest<MfLastVisitedData, GetMfLastVisitedRequest>({
    method: "POST",
    url: API_PATHS.getMfLastVisited,
    data: {
      mobile,
    },
  });
};
